module.exports = __webpack_public_path__ + "static/img/tab1.e6d453e4.jpg";